import axios from "axios";

const api = axios.create({
  // baseURL: "http://127.0.0.1:8000/tmsapi/",
  baseURL: "https://tuteby.com/tmsapi/",
  withCredentials: true
});


// 🔐 Request interceptor (attach token)
api.interceptors.request.use(
  (config) => {
    // const defaultToken = "Token 7cb28d377886684c1dd2b607baddde5239a39430";
    const defaultToken = "Token d25436ccf263a2b436bde60c95a577829fabf184";
    const utoken = sessionStorage.getItem("access");
    config.headers.Authorization = defaultToken;  // Use default token for testing
    if (utoken) {
      config.headers["user-token"] = `Bearer ${utoken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🚨 Response interceptor (handle errors globally)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Example: Token expired
      if (error.response.status === 401) {
        console.log("Unauthorized → redirect to login");
        sessionStorage.clear();
        window.location.href = "/signin";
      }
    }
    return Promise.reject(error);
  }
);


export default api;
